import { GirafeHTMLElement } from '@geogirafe/lib-geoportal/base';
import { Service } from '../service/service';
import { ErdbebenState } from '../../../bs/types';

class ErdbebenMikrozonierungComponent extends GirafeHTMLElement {
  templateUrl = './template.html';
  styleUrls = ['../../../../node_modules/@geogirafe/lib-geoportal/styles/common.css', '../item-style.css'];

  private readonly templateName = 'erdbebenmikrozonierungs_report';
  service!: Service;

  protected get reportState(): ErdbebenState {
    return this.state.extendedState[this.templateName] as ErdbebenState;
  }

  protected get reportConfig() {
    return this.context.configManager.Config.extendedConfig!.reportService;
  }

  constructor() {
    super('erdbeben-mikrozonierung-component');
  }

  private initialize() {
    if (!this.state.extendedState[this.templateName]) {
      this.state.extendedState[this.templateName] = {
        currentState: 'inactive'
      };
    }

    this.service = new Service(this.context);
  }

  protected override connectedCallback() {
    super.connectedCallback();
    this.initialize();
    super.render();
    this.registerEvents();
  }

  private registerEvents() {
    this.subscribe(`extendedState\.${this.templateName}\.currentState`, () => this.reportStateChanged());
    this.context.mapManager.getMap().on('singleclick', () => this.onMapClick());
  }

  protected onReportClick() {
    if (this.reportState.currentState === 'inactive') {
      this.reportState.currentState = 'active';
    } else if (this.reportState.currentState === 'active') {
      this.reportState.currentState = 'inactive';
    } else if (this.reportState.currentState === 'download') {
      window.open(this.reportState.downloadUrl);
      this.reportState.currentState = 'inactive';
    } else if (this.reportState.currentState === 'error') {
      this.reportState.currentState = 'inactive';
    }
  }

  private reportStateChanged() {
    if (this.reportState.currentState === 'active') {
      this.registerInteractionListener('map.mouseclick', true);
      this.updateCursorStyle();
    } else {
      this.unregisterInteractionListeners('map.mouseclick');
      this.updateCursorStyle();
    }
    this.refreshRender();
  }

  private updateCursorStyle() {
    const targetElement = this.context.mapManager.getMap().getTargetElement();
    targetElement.style.cursor = this.reportState.currentState === 'active' ? 'crosshair' : 'default';
  }

  async onMapClick() {
    if (!this.canExecute('map.mouseclick')) {
      return;
    }

    try {
      const coord = this.state.mouseCoordinates;
      const east = coord[0].toFixed(3);
      const north = coord[1].toFixed(3);

      // 1) WFS query
      this.reportState.currentState = 'processing';
      this.refreshRender();

      const isInZone = await this.service.getFeaturesFromWFS(Number(east), Number(north));
      if (isInZone) {
        // 2) Report
        const resultUrl = await this.service.createReport(this.templateName, `${east},${north}`);
        this.reportState.downloadUrl = resultUrl;
        this.reportState.currentState = 'download';
      } else {
        this.reportState.currentState = 'inactive';
        this.reportState.errorMessage = 'Für den gewählten Standort sind keine Daten verfügbar.';
      }
    } catch (err) {
      this.reportState.errorMessage = String(err);
      this.reportState.currentState = 'error';
    } finally {
      this.refreshRender();
    }
  }
}

export default ErdbebenMikrozonierungComponent;
